
export function changePosition(val) {
  switch (val) {
    case 'guochan':
      return '国产成人视频'
    case 'av':
      return '日本和欧美成人视频'
    case 'movie':
      return '正规影视资源'
    case 'bl':
      return '男同'
    case 'douyin':
      return '短视频'
    case 'cartoon':
      return '动漫'
    case 'dark':
      return '暗网资源'
      default:
        return '暂无'
  }
}

export function positionList() {
  return [{
    value: 'guochan',
    label: '国产成人视频'
  },
  {
    value: 'av',
    label: '日本和欧美成人视频'
  },
  {
    value: 'movie',
    label: '正规影视资源'
  },
  {
    value: 'bl',
    label: '男同'
  },
  {
    value: 'douyin',
    label: '短视频'
  },
  {
    value: 'cartoon',
    label: '动漫'
  },
  {
    value: 'dark',
    label: '暗网资源'
  }
  ]
}

export function changeVideoTypeList(val) {
  switch (val) {
    case '1':
      return 'AV'
    case '2':
      return 'DM'
    case '3':
      return 'GC'
    case '4':
      return '综艺'
    case '5':
      return '连续剧'
    case '6':
      return '电影'
    case '7':
      return '动漫'
       case '8':
      return '纪录片'
       case '9':
      return '短剧'
       case '10':
      return '音乐'
       case '11':
      return '电影解说  '
       case '12':
      return 'VR'
       case '13':
      return '成人短视频'
  }
}
export function videoTypeList() {
  return [{
    label: '1',
    value: 'AV'
  },
  {
    label: '2',
    value: 'DM'
  },
  {
    label: '3',
    value: 'GC'
  },
  {
    label: '4',
    value: '综艺'
  },
  {
    label: '5',
    value: '连续剧'
  },
  {
    label: '6',
    value: '电影'
  },
  {
    label: '7',
    value: '动漫'
  },{
    label: '8',
    value: '纪录片'
  },{
    label: '9',
    value: '短剧'
  },{
    label: '10',
    value: '音乐'
  },{
    label: '11',
    value: '电影解说'
  },{
    label: '12',
    value: 'VR'
  },{
    label: '13',
    value: '成人短视频'
  }
  ]
}
export function statusList() {
  return [{
    label: '0',
    value: '待处理'
  },
  {
    label: '-1',
    value: '处理失败'
  },
  {
    label: '1',
    value: '处理中'
  },
  {
    label: '2',
    value: '处理成功'
  }
  ]
}
export function changeStatusListType(val) {
  switch (val) {
    case '0':
      return '待处理'
    case '-1':
      return '处理失败'
    case '1':
      return '处理中'
    case '2':
      return '处理成功'
  }
}
